import React, { Component } from 'react';
import { Link } from 'react-router';
import { Badge, Divider, Icon, message, Popconfirm, Table } from 'antd';

import moment from 'moment';
import { querySetTaskCollect, querySetTaskUnCollect, queryTaskDiscard } from '@api/task';

class TableInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const { data } = this.props;
    this.setState({ data });
  }

  componentWillReceiveProps(nextProps) {
    const { data } = nextProps;
    if (data !== this.props.data) {
      this.setState({ data });
    }
  }

  setTaskCollect = record => {
    const { data } = this.state;

    querySetTaskCollect({ uuid: record.uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        record.collectFlag = true;
        this.setState({ data });
      } else {
        message.error(res.message);
      }
    });
  };

  setTaskUnCollect = record => {
    const { data } = this.state;

    querySetTaskUnCollect({ uuid: record.uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        record.collectFlag = false;
        this.setState({ data });
      } else {
        message.error(res.message);
      }
    });
  };

  // 废弃任务
  handleDisTask = uuid => {
    queryTaskDiscard({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.getProjTaskList();
      } else {
        message.error(res.message);
      }
    });
  };

  columns = () => {
    return [
      {
        title: '',
        dataIndex: 'collectFlag',
        width: 30,
        render: (text, record) => {
          if (text) {
            return (
              <Icon
                type="heart"
                style={{
                  color: 'red',
                }}
                theme="filled"
                onClick={() => this.setTaskUnCollect(record)}
              />
            );
          }
          return <Icon type="heart" theme="outlined" onClick={() => this.setTaskCollect(record)} />;
        },
      },
      {
        title: '任务名称',
        dataIndex: 'name',
        render: (text, record) => {
          return <Link to={`/task/task_detail/${record.uuid}`}>{text}</Link>;
        },
      },
      {
        title: '开始时间',
        dataIndex: 'beginDate',
        key: 'beginDate',
        render: (text, record) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '截至时间',
        dataIndex: 'endDate',
        key: 'endDate',
        render: (text, record) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '相关人员',
        dataIndex: 'executives',
        key: 'executives',
        render: (text, record) => {
          return (
            <div>
              <p>
                <span style={{ color: '#D8D1CF' }}>执</span>
                {record.executives.map(item => {
                  return (
                    <span style={{ paddingLeft: '5px', paddingRight: '5px' }} key={item.uuid}>
                      {item.userName}
                    </span>
                  );
                })}
              </p>
              <p style={{ marginBottom: '0' }}>
                <span style={{ color: '#D8D1CF' }}>协</span>
                {record.assistants.map(item => {
                  return (
                    <span style={{ paddingLeft: '5px', paddingRight: '5px' }} key={item.uuid}>
                      {item.userName}
                    </span>
                  );
                })}
              </p>
            </div>
          );
        },
      },
      {
        title: '状态',
        dataIndex: 'status',
        render: (text, record) => {
          if (record.status === 1) {
            switch (record.fettle) {
              case 1:
                return <Badge color="red" text="已逾期" />;
              case 2:
                return <Badge color="blue" text="进行中" />;
              case 3:
                return <Badge color="yellow" text="未开始" />;
              default:
            }
          } else if (record.status === 2) {
            switch (record.fettle) {
              case 1:
                return <Badge color="red" text="未完成" />;
              case 2:
                return <Badge color="green" text="已完成" />;
              case 3:
                return <Badge color="gray" text="已废弃" />;
              default:
            }
          } else if (record.status === 0) {
            return <Badge color="yellow" text="待编辑" />;
          }
        },
      },
      {
        title: '操作',
        dataIndex: 'done',
        render: (text, record) => {
          switch (record.status) {
            case 0:
              return <Link onClick={() => this.editProjTask(record.uuid)}>编辑</Link>;
            case 1:
              return (
                <div>
                  <Link onClick={() => this.props.editProjTask(record.uuid)}>编辑</Link>
                  {record.fettle === 2 && record.status === 3 ? '' : <Divider type="vertical" />}

                  <Popconfirm
                    placement="leftTop"
                    title="确定废弃任务吗？"
                    onConfirm={() => this.handleDisTask(record.uuid)}
                    okText="确定"
                    cancelText="取消"
                  >
                    <a>废弃</a>
                  </Popconfirm>
                </div>
              );
            case 2:
              return <div />;
            default:
          }
        },
      },
    ];
  };

  render() {
    const { data, pagination, isLoading } = this.props;
    return (
      <Table
        size="small"
        rowKey="uuid"
        dataSource={data}
        loading={isLoading}
        pagination={pagination}
        columns={this.columns()}
        onChange={this.props.onChange}
      />
    );
  }
}

export default TableInformation;



// WEBPACK FOOTER //
// ./src/components/task/project/pageDetailManage/TableTask.js